import * as React from "react";
import { styled } from "@mui/material/styles";
import "../App.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Stack } from "@mui/material";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import { useState, useEffect } from "react";
import { useOtpSettings } from "./OtpContext";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import DownloadIcon from "@mui/icons-material/Download";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import axios from "axios";
import { Modal } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { getInstituteConfig } from "../utility/instituteConfig";

export default function Refund({ props }) {
  let {
    studentName,
    studentId,
    academicYearId,
    gradeName,
    userId,
    sectionName,
    sectionId,
    userMail,
  } = props;
  const [refundId, setrefundId] = useState();
  const [refundAmount, setRefundAmount] = useState(0);
  const [description, setDescription] = useState("");
  const [refundTypeName, setRefundTypeName] = useState("");

  const [refundType, setRefundType] = useState([{}]);

  const [refundTypeId, setRefundTypeId] = useState();

  const [refundPayment, setRefundPayment] = useState([]);

  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarMessageColor, setSnackbarMessageColor] = useState("");
  const [showSnackbarMessage, setShowSnackbarMessage] = useState(false);

  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("fees_slab");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [refundAmountError, setRefundAmountError] = useState(false);
  const [refundDateError, setrefundDateError] = useState(false);
  const [refundTypeError, setRefundTypeError] = useState(false);

  const [oldRefundAmount, setOldRefundAmount] = useState(0);
  const [oldDescription, setOldDescription] = useState("");
  const [oldRefundDate, setOldRefundDate] = useState();

  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  // const [email, setEmail] = useState(process.env.REACT_APP_EMAIL);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [backendOtp, setBackendOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [verifyOTPMsg, setVerifyOTPMsg] = useState("");
  const [resendTimer, setResendTimer] = useState(600);
  const [canResend, setCanResend] = useState(true);
  const [resendCount, setResendCount] = useState(1); // Counter for resend attempts
  const [isLoading, setIsLoading] = useState(false);

  const [validateData, setVAlidateData] = useState({
    fees_payment: {
      total_paid: 0,
      total_pending: 0,
      entries: [],
    },
    store_payment: {
      total_paid: 0,
      total_pending: 0,
      entries: [],
    },
    transport_payment: {
      total_paid: 0,
      total_pending: 0,
      entries: [],
    },
    annual_subscription_payment: {
      total_paid: 0,
      total_pending: 0,
      entries: [],
    },
  }); // Counter for resend attempts
  const [feesAmount, setFeesAmount] = useState(0);
  const [annualPaymentAmount, setAnnualPaymentAmount] = useState(0);
  const [transportAmount, setTransportAmount] = useState(0);
  const instituteId = localStorage.getItem("instituteId");

  const instituteEmailMap = {
    "1": process.env.REACT_APP_EMAIL_JHS,
    "2": process.env.REACT_APP_EMAIL_JPS,
  };
  const [email, setEmail] = useState(instituteEmailMap[instituteId]);
  const navigate = useNavigate();
  const { isOtpEnabled } = useOtpSettings();
  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Ensure 2-digit month
    const day = String(today.getDate()).padStart(2, "0"); // Ensure 2-digit day
    return `${year}-${month}-${day}`;
  };
  const [refundDate, setrefundDate] = useState(getTodayDate);
  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          process.env.REACT_APP_JHS_DEVELOPMENT +
            "/paymentSummary/getpaymentSummary",
          {
            method: "POST",
            headers: { "Content-type": "application/json" },
            credentials: "include",

            body: JSON.stringify({
              student_id: studentId,
              academic_year_id: academicYearId,
            }),
          },
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const result = await response.json();
        console.log("API Response:", result); // Check the response structure

        // Access the payments data
        setVAlidateData({
          fees_payment:
            result.fn_get_payment_summary_by_student_id_academic_year_id
              .fees_payment || [],
          store_payment:
            result.fn_get_payment_summary_by_student_id_academic_year_id
              .store_payment || [],
          transport_payment:
            result.fn_get_payment_summary_by_student_id_academic_year_id
              .transport_payment || [],
          annual_subscription_payment:
            result.fn_get_payment_summary_by_student_id_academic_year_id
              .annual_subscription_payment || [],
        });
        setFeesAmount(
          result.fn_get_payment_summary_by_student_id_academic_year_id
            .fees_payment.total_paid,
        );
        console.log(
          "fees total",
          result.fn_get_payment_summary_by_student_id_academic_year_id
            .fees_payment.total_paid,
        );
        setAnnualPaymentAmount(
          result.fn_get_payment_summary_by_student_id_academic_year_id
            .annual_subscription_payment.total_paid,
        );
        console.log(
          "Annual total",
          result.fn_get_payment_summary_by_student_id_academic_year_id
            .annual_subscription_payment.total_paid,
        );
        setTransportAmount(
          result.fn_get_payment_summary_by_student_id_academic_year_id
            .transport_payment.total_paid,
        );
        console.log(
          "Transport total",
          result.fn_get_payment_summary_by_student_id_academic_year_id
            .transport_payment.total_paid,
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    console.log("grade", gradeName);
  }, [studentId]);
  //Simran........ added pagination and sorting
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    // Reset to default sorting when students are fetched
    setOrder("desc");
    setOrderBy("refund_id");
  }, [refundPayment]);

  // Sorting function
  // Sorting function
  const handleRequestSort = (property) => {
    const isAscending = orderBy === property && order === "asc";
    setOrder(isAscending ? "desc" : "asc");
    setOrderBy(property);
  };
  const descendingComparator = (a, b, orderBy) => {
    if (orderBy === "slno") {
      // Sort by Serial No. (index)
      return a.index < b.index ? -1 : 1;
    }
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  };

  const getComparator = (order, orderBy) => {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  };

  // Sort the rows before displaying them
  const sortedRows = refundPayment
    .map((row, index) => ({ ...row, index: index + 1 })) // Add index for Serial No.
    .sort(getComparator(order, orderBy));

  const handleRefundTypeChange = (event) => {
    setRefundTypeName(event.target.value);
    let selectedRefund = refundType.find(
      (fr) => fr.refund_type_name === event.target.value,
    );
    setRefundTypeId(selectedRefund.refund_type_id);
    setRefundTypeError("");
  };

  const handleSelectRow = (
    refundId,
    refundTypeName,
    refundAmount,
    refundDate,
    description,
  ) => {
    // setRefundTypeId(refundType);
    console.log(refundId);
    setrefundId(refundId);
    console.log("ArohiREfundTYpe", refundTypeName);
    setRefundTypeName(refundTypeName);
    setRefundAmount(refundAmount);

    console.log("description", description);
    setDescription(description);
    const formattedDate = new Date(refundDate).toISOString().split("T")[0];
    setrefundDate(formattedDate); // Set the formatted date

    setrefundDate(refundDate);

    setOldRefundAmount(refundAmount);
    setOldRefundDate(refundDate);
    setOldDescription(description);
    setRefundAmountError("");
    setRefundTypeError("");
  };

  useEffect(() => {
    getRefundType();
  }, []);

  const getRefundType = async () => {
    fetch(process.env.REACT_APP_JHS_DEVELOPMENT + "/refund/getRefundType", {
      method: "GET",
      headers: { "Content-type": "application/json" },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch refund type");
        }
        return response.json();
      })
      .then((response) => {
        setRefundType(response);
      })
      .catch((error) => {
        console.error("Error fetching refund type:", error);
        // Optionally show an alert or error message
      });
  };

  useEffect(() => {
    getRefundPayment();
  }, [academicYearId, studentId]);

  const getRefundPayment = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/refund/getRefund",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            academic_year_id: academicYearId,
            student_id: studentId,
          }),
        },
      );

      const data = await response.json();

      if (data.length > 0) {
        const paymentDetails = data;
        setRefundPayment(paymentDetails);
      }
    } catch (error) {
      console.error("Error fetching refund data:", error);
    }
  };

  const addRefund = () => {
    let refundTypeError = "";
    let refundDateError = "";
    let refundAmountError = "";
    let refundSpecificError = "";

    if (!refundTypeName || parseFloat(refundTypeName) === 0) {
      refundTypeError = "Select Refund Type";
    }

    if (!refundAmount || parseFloat(refundAmount) === 0) {
      refundAmountError = "Refund Amount is required";
    }

    // Validate Payment Date
    if (!refundDate || refundDate.trim() === "") {
      refundDateError = "Refund Date is required";
    }

    // Specific Validations
    if (refundTypeName === "Inventory" && !refundId) {
      refundSpecificError =
        "Inventory refunds can only be added through Inventory Refund tab.";
    } else if (refundTypeName === "Fees" && refundAmount > feesAmount) {
      refundSpecificError =
        "Refund cannot be processed because no fees payment has been made by the student.";
    } else if (
      refundTypeName === "Annual Subscription" &&
      refundAmount > annualPaymentAmount
    ) {
      refundSpecificError =
        "Refund cannot be processed because no annual subscription payment has been made by the student.";
    } else if (
      refundTypeName === "Transport" &&
      refundAmount > transportAmount
    ) {
      refundSpecificError =
        "Refund cannot be processed because no transport payment has been made by the student.";
    }

    // Set errors and return if any validations fail
    if (
      refundAmountError ||
      refundDateError ||
      refundTypeError ||
      refundSpecificError
    ) {
      setRefundAmountError(refundAmountError);
      setrefundDateError(refundDateError);
      setRefundTypeError(refundTypeError);

      return; // Prevent form submission if there are errors
    }

    // Reset error state after successful validation
    setRefundTypeError("");
    setRefundAmountError("");
    setrefundDateError("");
    setRefundTypeError("");
    setIsLoading(true); // Start loading
    // Proceed with form submission
    fetch(`${process.env.REACT_APP_JHS_DEVELOPMENT}/refund/saveRefund`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        refund_id: refundId,
        student_id: studentId,
        refund_type_id: refundTypeId,
        refund_amount: refundAmount,
        refund_date: refundDate,
        academic_year_id: academicYearId,
        description: description,
        created_by: userId,
      }),
    })
      .then((response) => {
        if (response.status === 401) {
          console.log("Unauthorized access, redirecting to Sign-In...");
          navigate("/signin"); // Redirect to Sign-In page if unauthorized
          return; // Stop further execution
        }
        if (!response.ok) {
          throw new Error("Failed to submit refund data");
        }
        return response.json();
      })
      .then((response) => {
        handleResponse(response); // Handle response after successful submission
      })
      .catch((error) => {
        console.error("Error submitting refund details:", error);
        // Optionally show an alert or handle error UI
      })
      .finally(() => {
        setIsLoading(false); // Stop loading
      });
  };
  const handleResponse = (responseObject) => {
    if (responseObject.status === 200) {
      getRefundPayment();
      const message = refundId ? "Refund updated successfully" : "Refund added successfully";
      setSnackbarMessage(message);
      setSnackbarMessageColor("success");
      setShowSnackbarMessage(true);
      reset();
    }
    if (responseObject.status === 400) {
      setSnackbarMessage(responseObject.error);
      setSnackbarMessageColor("error");
      setShowSnackbarMessage(true);
    }
  };

  const reset = () => {
    setRefundTypeName("");
    setRefundAmount("");
    setDescription("");
    setrefundDate(getTodayDate);
    setrefundId(0);
  };
  const saveRefund = () => {
    let refundTypeError = "";
    let refundDateError = "";
    let refundAmountError = "";

    if (!refundTypeName || parseFloat(refundTypeName) === 0) {
      refundTypeError = "Select Refund Type";
    }

    if (!refundAmount || parseFloat(refundAmount) === 0) {
      refundAmountError = "Refund Amount is required";
    }

    // Validate Payment Date
    if (!refundDate || refundDate.trim() === "") {
      refundDateError = "Refund Date is required";
    }

    // Set errors and return if any validations fail
    if (refundAmountError || refundDateError || refundTypeError) {
      setRefundAmountError(refundAmountError);
      setrefundDateError(refundDateError);
      setRefundTypeError(refundTypeError);

      return; // Prevent form submission if there are errors
    }

    // Reset error state after successful validation
    setRefundAmountError("");
    setrefundDateError("");
    fetch(process.env.REACT_APP_JHS_DEVELOPMENT + "/refund/editRefund", {
      method: "POST",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify({
        refund_id: refundId,
        refund_date: refundDate,
        description: description,
        updated_timestamp: new Date(),
        updated_by: userId,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        handleResponse(response);
      });
  };
  const handleDownload = async (row, event) => {
    event.stopPropagation();
    const doc = new jsPDF();

    const institute = getInstituteConfig(instituteId);

    // Add Logo and Header
    doc.setFillColor("#0A64A2");
    const headerHeight = 20;
    doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");
    doc.setFontSize(14);
    doc.setTextColor(255, 255, 255);
    const textyy = 11;
    doc.setFont("helvetica", "bold");

    // School name
    doc.text(
      institute.name, // ✅ dynamic
      doc.internal.pageSize.getWidth() / 2,
      textyy,
      { align: "center" },
    );

    // Logo
    if (institute.logo) {
      doc.addImage(institute.logo, "PNG", 8, 1, 28, 18); // ✅ dynamic
    }

    // Address
    doc.setTextColor(0, 0, 0);
    const textStartY = 15;
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(
      institute.address1, // ✅ dynamic
      doc.internal.pageSize.getWidth() / 2,
      textStartY + 10,
      { align: "center" },
    );
    doc.text(
      institute.address2, // ✅ dynamic
      doc.internal.pageSize.getWidth() / 2,
      textStartY + 14,
      { align: "center" },
    );
    if (institute.tel) {
      doc.text(
        institute.tel, // ✅ dynamic, skipped for JPS
        doc.internal.pageSize.getWidth() / 2,
        textStartY + 18,
        { align: "center" },
      );
    }

    // Add Receipt Title, Number, and Date - Right aligned
    const receiptTextY = textStartY + 30; // Position the receipt content slightly lower
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(
      `${row.refund_type_name.toUpperCase()} REFUND RECEIPT`,
      doc.internal.pageSize.getWidth() / 2,
      receiptTextY,
      { align: "center" },
    ); // Center aligned title
    doc.setFontSize(10);

    const studentDetailsY = receiptTextY + 10; // Adjust Y position after receipt info

    // Set font for student name and details
    doc.setFont("helvetica", "bold");
    const studentLabelX = 14;

    // Constants for padding and maximum widths
    const PADDING = 5; // Uniform padding between elements
    const MAX_NAME_WIDTH = 70; // Max width for student name before wrapping

    // Handle long student name
    const studentname = `${studentName || ""}`;
    const studentNameWidth = doc.getTextWidth(studentname);
    const splitStudentName =
      studentNameWidth > MAX_NAME_WIDTH
        ? doc.splitTextToSize(studentname, MAX_NAME_WIDTH)
        : studentname;

    doc.text(`Name of Student: `, studentLabelX, studentDetailsY); // Left aligned
    doc.setFont("helvetica", "normal");
    doc.text(splitStudentName, studentLabelX + 30, studentDetailsY); // Adjust X position for student name

    // Dynamically calculate X position for Grade based on student name
    const studentNameActualWidth = Math.min(studentNameWidth, MAX_NAME_WIDTH); // Use actual width or max width
    const gradeX = studentLabelX + 30 + studentNameActualWidth + PADDING;

    // Grade
    doc.setFont("helvetica", "bold");
    doc.text(`Grade:`, gradeX, studentDetailsY);
    const gradeLabelWidth = doc.getTextWidth(`Grade: `);
    doc.setFont("helvetica", "normal");
    const gradeValue = `${gradeName || ""}`;
    doc.text(gradeValue, gradeX + gradeLabelWidth, studentDetailsY);

    // Dynamically calculate X position for Section based on Grade
    const gradeValueWidth = doc.getTextWidth(gradeValue);
    const sectionX = gradeX + gradeLabelWidth + gradeValueWidth + PADDING;

    // Section
    doc.setFont("helvetica", "bold");
    doc.text(`Section:`, sectionX, studentDetailsY);
    const sectionLabelWidth = doc.getTextWidth(`Section: `);
    doc.setFont("helvetica", "normal");
    const sectionValue = `${sectionName || ""}`;
    const sectionValueWidth = doc.getTextWidth(sectionValue);

    // Check if Section exceeds page width and adjust
    if (
      sectionX + sectionLabelWidth + sectionValueWidth >
      doc.internal.pageSize.width
    ) {
      // Move to the next line if it exceeds the page width
      studentDetailsY += 10; // Adjust Y position
      doc.text(`Section:`, studentLabelX, studentDetailsY); // Start from the left
      doc.text(
        sectionValue,
        studentLabelX + sectionLabelWidth,
        studentDetailsY,
      );
    } else {
      // Place Section normally
      doc.text(sectionValue, sectionX + sectionLabelWidth, studentDetailsY);
    }
    const receiptDetails = [
      { title: "Refund ID", value: row.refund_id },
      { title: "Refund Type", value: row.refund_type_name },
      { title: "Refund Amount", value: row.refund_amount },
      { title: "Refund Date", value: row.refund_date },
      { title: "Description", value: row.description },
    ];

    // Fetch product details if the refund type is "Inventory"
    if (row.refund_type_name === "Inventory") {
      try {
        const response = await fetch(
          process.env.REACT_APP_JHS_DEVELOPMENT + "/refund/getStudentRefund",
          {
            method: "POST",
            headers: { "Content-type": "application/json" },
            credentials: "include",
            body: JSON.stringify({
              refund_id: row.refund_id,
            }),
          },
        );
        if (response.status === 401) {
          console.log("Unauthorized access, redirecting to Sign-In...");
          navigate("/signin"); // Redirect to Sign-In page if unauthorized
          return; // Stop further execution
        }
        const productDetails = await response.json(); // Parse response
        console.log("Fetched Product Details:", productDetails);

        if (productDetails.length > 0) {
          const productsValue = productDetails[0].map((product, index) => {
            return `${index + 1}. Product: ${product.product_name},  Quantity: ${product.quantity},  Price: ${product.price}`;
          });
          // Join all products with line breaks
          // Add the product list to receiptDetails
          receiptDetails.push({
            title: "Product List",
            value: productsValue.join("\n"),
          });
        }
      } catch (error) {
        console.error("Error fetching product details:", error);
      }
    } else {
      console.warn(
        "No product details available for refund ID:",
        row.refund_id,
      );
    }
    doc.autoTable({
      head: [["Particulars", "Amount"]],
      body: receiptDetails.map((item) => [item.title, item.value]),
      startY: receiptTextY + 13, // Start table below student details
      styles: { fontSize: 10, cellPadding: 2 }, // Adjust padding for consistency
      headStyles: {
        fillColor: "#0A64A2", // Blue header
        textColor: [255, 255, 255], // White text
        halign: "left", // Center-align header text
      },
      bodyStyles: {
        halign: "left", // Align text to the left in the body
      },
      columnStyles: {
        0: { cellWidth: 90, halign: "left" }, // Fixed width for the "Particulars" column
        1: { cellWidth: 90, halign: "left" }, // Fixed width for the "Amount" column
      },
      theme: "grid",
    });
    const currentDate = new Date();

    // Format the date as DD/MM/YYYY
    const formattedDate = `${String(currentDate.getDate()).padStart(2, "0")}/${String(currentDate.getMonth() + 1).padStart(2, "0")}/${currentDate.getFullYear()}`;

    // Add the text with the current date
    doc.setFont("helvetica", "bold");
    doc.text(`Date: ${formattedDate}`, 14, doc.previousAutoTable.finalY + 40);
    doc.setFont("helvetica", "bold");
    doc.text("Authorized Signatory", 158, doc.previousAutoTable.finalY + 40); // Right aligned for signature

    // Save the PDF
    doc.save(
      `${row.refund_type_name}_refund_receipt_${new Date().toISOString().slice(0, 10)}.pdf`,
    );
  };

  const handleGetOtp = async () => {
    const otpRequiredForRefund = isOtpEnabled('Refund');
 if (!otpRequiredForRefund) {
    if (refundId) {
      // ✅ Check for changes before saving
      const hasChanges =
        oldRefundDate !== refundDate ||
        oldDescription !== description;

      if (!hasChanges) {
        setSnackbarMessage("No changes detected.");
        setSnackbarMessageColor("error");
        setShowSnackbarMessage(true);
        return;
      }

      saveRefund();
    } else {
      addRefund();
    }
    return;
  }
    setSnackbarMessage("OTP sent successfully.");
    setSnackbarMessageColor("success");
    setShowSnackbarMessage(true);
    try {
      const paymentDetails = {
        refund_amount: refundAmount,
        refund_date: refundDate,
        description: description,
      };
      const paymentType = "Refund Payment";
      const paymentId = refundId;

      // Assuming you have a way to get the oldPaymentDetails
      const oldPaymentDetails = {
        refund_amount: oldRefundAmount,
        refund_date: oldRefundDate,
        description: oldDescription,
      };
      setEmail(process.env.REACT_APP_EMAIL);

      const response = await axios.post(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/send-otp/getOtp",
        {
          email,
          userMail,
          paymentId,
          updatedPaymentDetails: paymentDetails,
          oldPaymentDetails: oldPaymentDetails, // Include old details here
          userId: userId,
          paymentType,
          studentName,
          gradeName,
          sectionName,
        },
        { withCredentials: true },
      );

      console.log(response.data.message);
      if (response.data.otp) {
        setBackendOtp(response.data.otp);
        setOtpSent(true);
        setResendTimer(600);
        setCanResend(false);
        setOtp(["", "", "", "", "", ""]);
        console.log("otp", paymentDetails);
        setIsOtpModalOpen(true); // Open OTP modal
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      setSnackbarMessage("No changes detected.");
      setSnackbarMessageColor("error");
      setShowSnackbarMessage(true);
      if (error.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin"); // ✅ Fix: Ensure correct spelling
        return;
      }
      // setTimeout(() => {
      //   reset();
      // }, 2000);
    }
  };

  const handleVerifyOtp = (event) => {
    event.preventDefault();
    const enteredOtp = otp.join(""); // Combine the entered OTP from the input boxes

    // Check if the OTP field is empty
    if (!enteredOtp) {
      setVerifyOTPMsg("Please enter the OTP");
      return;
    }

    // Check if the entered OTP matches the backend OTP
    if (enteredOtp === backendOtp) {
      setVerifyOTPMsg("OTP Verified Successfully");
      saveRefund();
      setIsOtpModalOpen(false); // Close the modal on successful verification
      setOtp(["", "", "", "", "", ""]);
      setVerifyOTPMsg(""); // Clear any verification message
      setResendCount(0); // Reset resend count
      setResendTimer(600); // Reset resend timer
      setCanResend(true); // Disable resend button
    } else {
      setVerifyOTPMsg("Invalid OTP"); // Show this if the OTP is incorrect
    }
  };
  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]$/.test(value) || value === "") {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Focus on the next input
      if (value !== "" && index < otp.length - 1) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
      // Focus on the previous input
      if (value === "" && index > 0) {
        document.getElementById(`otp-input-${index - 1}`).focus();
      }
    }
  };

  // Add this useEffect to handle the countdown timer
  useEffect(() => {
    let intervalId;

    if (isOtpModalOpen && resendTimer > 0 && !canResend) {
      intervalId = setInterval(() => {
        setResendTimer((prevTimer) => {
          if (prevTimer <= 1) {
            setCanResend(true);
            clearInterval(intervalId);
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [isOtpModalOpen, canResend, resendTimer]);

  // Format time to MM:SS
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(remainingSeconds).padStart(2, "0")}`;
  };

  const handleResendOtp = () => {
    if (canResend && resendCount < 3) {
      setResendCount((prev) => prev + 1);
      handleGetOtp(); // Triggers OTP generation and email
      setCanResend(false); // Disable until timer ends
      setResendTimer(600); // Restart the timer
    } else {
      setVerifyOTPMsg(
        "You have reached the maximum number of resend attempts.",
      );
    }
  };

  const handleCloseModal = () => {
    setIsOtpModalOpen(false);

    // Reset all states related to OTP input, verification, and timers
    setOtp(["", "", "", "", "", ""]); // Reset OTP fields
    setVerifyOTPMsg(""); // Clear any verification message
    setResendCount(0); // Reset resend count
    setResendTimer(600); // Reset resend timer
    setCanResend(true); // Disable resend button
    setrefundId("");
    reset();
  };

  return (
    <div>
      <div className="main_title">Refund</div>
      <br />
      <Stack spacing={10} direction="row">
        <Stack spacing={1} direction="column" className="form-stack">
          <TextField
            className="text-field"
            variant="outlined"
            size="small"
            required
            label={refundTypeError ? refundTypeError : "Select Refund Type"}
            error={!!refundTypeError}
            id="demo-simple-select"
            name="refundType"
            value={refundTypeName}
            onChange={handleRefundTypeChange}
            select
            disabled={refundId}
          >
            {refundType.map((rt) => {
              return (
                <MenuItem value={rt.refund_type_name} key={rt.refund_type_id}>
                  {rt.refund_type_name}
                </MenuItem>
              );
            })}
          </TextField>

          <TextField
            disabled={refundTypeName === "Inventory" || refundId}
            id="outlined-basic"
            error={!!refundAmountError}
            label={refundAmountError ? refundAmountError : "Refund Amount"}
            value={refundAmount}
            onChange={(event) => {
              const value = event.target.value;

              // Allow only numbers and limit the input length to 7 digits
              if (value.length <= 7 && /^\d*$/.test(value)) {
                setRefundAmount(value);
              }

              setRefundAmountError("");
            }}
            type="number"
            onFocus={() => {
              // Clear the field when it's focused and the initial value is 0
              if (refundAmount === 0) {
                setRefundAmount("");
              }
            }}
            size="small"
            variant="outlined"
            inputProps={{ maxLength: 7 }}
            className="text-field"
            required
          />

          {/* <Stack spacing={1} direction="column" className="form-stack"> */}
          <TextField
            disabled={refundTypeName === "Inventory"}
            id="outlined-basic"
            error={!!refundDateError}
            type="date"
            required
            // inputProps={{ max: new Date().toISOString().split("T")[0] }}
            defaultValue={null}
            value={refundDate}
            name="refundDate"
            onChange={(event) => {
              setrefundDate(event.target.value);
              setrefundDateError("");
            }}
            size="small"
            variant="outlined"
            className="text-field"
            label={refundDateError ? refundDateError : "Refund Date"}
            InputLabelProps={{ shrink: true }}
            sx={{
              '& input[type="date"]::-webkit-calendar-picker-indicator': {
                cursor: "pointer", // Change cursor to pointer for the calendar icon
              },
            }}
          />
        </Stack>

        <Stack spacing={1} direction="column">
          <TextField
            disabled={refundTypeName === "Inventory" && !refundId}
            id="outlined-basic"
            value={description}
            onChange={(event) => {
              setDescription(event.target.value);
            }}
            size="small"
            multiline
            rows={3}
            label="Description"
            variant="outlined"
            inputProps={{ maxLength: 250 }}
            className="description-field-feePayment"
          />
          <Button
            className="save_update_btn"
            variant="contained"
            disabled={isLoading}
            onClick={() => {
              if (refundId) {
                let refundTypeError = "";
                let refundDateError = "";
                let refundAmountError = "";
                let refundSpecificError = "";

                if (!refundTypeName || parseFloat(refundTypeName) === 0) {
                  refundTypeError = "Select Refund Type";
                }

                if (!refundAmount || parseFloat(refundAmount) === 0) {
                  refundAmountError = "Refund Amount is required";
                }

                // Validate Payment Date
                if (!refundDate || refundDate.trim() === "") {
                  refundDateError = "Refund Date is required";
                }

                // Set errors and return if any validations fail
                if (refundAmountError || refundDateError || refundTypeError) {
                  setRefundAmountError(refundAmountError);
                  setrefundDateError(refundDateError);
                  setRefundTypeError(refundTypeError);

                  return; // Prevent form submission if there are errors
                }

                // Reset error state after successful validation
                setRefundAmountError("");
                setrefundDateError("");
                handleGetOtp();
              } else {
                addRefund();
              }
            }}
            style={{ alignSelf: "flex-end" }}
            backgroundColor="#0A64A2"
          >
            {isLoading ? "Saving..." : refundId ? "Update" : "Save"}
          </Button>
        </Stack>
      </Stack>
      {/* Conditional message display */}

      {refundTypeName === "Inventory" && !refundId && (
        <div style={{ color: "red", marginTop: "8px" }}>
          Inventory refunds can only be added through Inventory Refund tab.
        </div>
      )}
      {refundTypeName === "Fees" && !feesAmount && (
        <div style={{ color: "red", marginTop: "8px" }}>
          Refund cannot be processed because no fees payment has been made by
          the Student.
        </div>
      )}
      {refundTypeName === "Transport" && !transportAmount && (
        <div style={{ color: "red", marginTop: "8px" }}>
          Refund cannot be processed because no transport payment has been made
          by the Student.
        </div>
      )}
      {refundTypeName === "Annual Subscription" && !annualPaymentAmount && (
        <div style={{ color: "red", marginTop: "8px" }}>
          Refund cannot be processed because no annual subscription payment has
          been made by the Student.
        </div>
      )}

      {/* refund is greater than total amount */}
      {refundTypeName === "Fees" && feesAmount && refundAmount > feesAmount && (
        <div style={{ color: "red", marginTop: "8px" }}>
          Refund cannot exceed fees payment of ₹{feesAmount} made by the
          Student.
        </div>
      )}
      {refundTypeName === "Transport" &&
        transportAmount &&
        refundAmount > transportAmount && (
          <div style={{ color: "red", marginTop: "8px" }}>
            Refund cannot exceed transport payment of ₹{transportAmount} made by
            the Student.
          </div>
        )}
      {refundTypeName === "Annual Subscription" &&
        annualPaymentAmount &&
        refundAmount > annualPaymentAmount && (
          <div style={{ color: "red", marginTop: "8px" }}>
            Refund cannot exceed annual subscription payment of ₹
            {annualPaymentAmount} made by the Student.
          </div>
        )}
      <br />

      <div className="main_title">Refund Payments of {studentName}</div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }}>
          <TableHead className="table-header">
            <TableRow>
              <TableCell className="table-cell" align="center">
                <TableSortLabel
                  className="table-sort-label "
                  active={orderBy === "refund_id"}
                  direction={orderBy === "refund_id" ? order : "asc"}
                  onClick={() => handleRequestSort("refund_id")}
                >
                  Refund Id
                  {orderBy === "refund_id" ? (
                    <span style={visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </span>
                  ) : null}
                </TableSortLabel>
              </TableCell>
              <TableCell className="table-cell" align="center">
                <TableSortLabel
                  className="table-sort-label "
                  active={orderBy === "refund_type"}
                  direction={orderBy === "refund_type" ? order : "asc"}
                  onClick={() => handleRequestSort("refund_type")}
                >
                  Refund Type
                  {orderBy === "refund_type" ? (
                    <span style={visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </span>
                  ) : null}
                </TableSortLabel>
              </TableCell>
              <TableCell className="table-cell" align="center">
                <TableSortLabel
                  className="table-sort-label "
                  active={orderBy === "refund_amount"}
                  direction={orderBy === "refund_amount" ? order : "asc"}
                  onClick={() => handleRequestSort("refund_amount")}
                >
                  Refund Amount
                  {orderBy === "refund_amount" ? (
                    <span style={visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </span>
                  ) : null}
                </TableSortLabel>
              </TableCell>

              <TableCell align="center" className="table-cell">
                <TableSortLabel
                  className="table-sort-label "
                  active={orderBy === "refund_date"}
                  direction={orderBy === "refund_date" ? order : "asc"}
                  onClick={() => handleRequestSort("refund_date")}
                >
                  Refund Date
                  {orderBy === "refund_date" ? (
                    <span style={visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </span>
                  ) : null}
                </TableSortLabel>
              </TableCell>

              <TableCell align="center" className="table-cell">
                <TableSortLabel
                  className="table-sort-label "
                  active={orderBy === "description"}
                  direction={orderBy === "description" ? order : "asc"}
                  onClick={() => handleRequestSort("description")}
                >
                  Description
                  {orderBy === "description" ? (
                    <span style={visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </span>
                  ) : null}
                </TableSortLabel>
              </TableCell>
              <TableCell align="center" className="table-sort-label-recipt">
                Receipt
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {(rowsPerPage > 0
              ? sortedRows.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage,
                )
              : sortedRows
            ).map((row, i) => (
              <StyledTableRow
                key={row.refund_id}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  handleSelectRow(
                    row.refund_id,
                    row.refund_type_name,
                    row.refund_amount,
                    row.refund_date,
                    row.description,
                  );
                }}
                tabIndex={-1}
              >
                <StyledTableCell align="center" sx={{ paddingLeft: "0" }}>
                  {row.refund_id}
                </StyledTableCell>
                <StyledTableCell align="center" sx={{ paddingLeft: "0" }}>
                  {row.refund_type_name}
                </StyledTableCell>
                <StyledTableCell align="center" sx={{ paddingLeft: "0" }}>
                  {row.refund_amount}
                </StyledTableCell>
                <StyledTableCell align="center" sx={{ paddingLeft: "0" }}>
                  {row.refund_date}
                </StyledTableCell>
                <StyledTableCell align="center" sx={{ paddingLeft: "0" }}>
                  {row.description}
                </StyledTableCell>
                <StyledTableCell align="center">
                  <Button
                    onClick={(event) => handleDownload(row, event)}
                    variant="text"
                    startIcon={<DownloadIcon />}
                  />
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                sx={{ backgroundColor: "#0A64A2", color: "white" }}
                rowsPerPageOptions={[5, 10, 25]}
                colSpan={7}
                count={refundPayment.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>

      <Snackbar
        open={showSnackbarMessage}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => {
          setShowSnackbarMessage(false);
        }}
        message={snackbarMessage}
      >
        <Alert
          severity={snackbarMessageColor}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Modal open={isOtpModalOpen} onClose={handleCloseModal}>
        <Box className="modalStyle">
          {/* Close Button in the top-right corner */}
          <IconButton
            aria-label="close"
            onClick={handleCloseModal}
            style={{ position: "absolute", top: 7, right: 10 }}
          >
            <CloseIcon />
          </IconButton>

          <h3 className="enter-otp">Enter OTP</h3>
          <Divider className="divider" />
          {verifyOTPMsg && <p className="invalid-otp">{verifyOTPMsg}</p>}

          {/* OTP Input Boxes */}
          <div className="otp-container">
            {otp.map((data, index) => (
              <TextField
                autoFocus={index === 0}
                key={index}
                value={data}
                onChange={(e) => handleOtpChange(e, index)}
                inputProps={{
                  maxLength: 1,
                  id: `otp-input-${index}`, // Set id for focus management
                  style: {
                    textAlign: "center", // Center the text inside
                    fontSize: "17px", // Font size adjustment
                    width: "40px", // Set width and height equal to make it square
                    height: "40px", // Set width and height equal to make it square
                    padding: 0, // Remove default padding
                    boxSizing: "border-box", // Ensure borders don't affect the box size
                  },
                }}
                InputProps={{
                  style: {
                    textAlign: "center",
                  },
                }}
                sx={{
                  "& .MuiInputBase-input": {
                    padding: 0, // Remove extra padding to keep it square
                  },
                }}
              />
            ))}
          </div>

          {/* Verify and Resend OTP Message */}
          <div className="otp-btn-container">
            {/* Resend OTP Control */}
            {canResend ? (
              <p
                className="resend-otp"
                style={{ color: "green", cursor: "pointer" }}
                onClick={handleResendOtp}
              >
                Resend OTP {resendCount}/3
              </p>
            ) : (
              <p style={{ color: "red" }}>
                Resend OTP in {formatTime(resendTimer)}
              </p>
            )}

            <Button
              variant="contained"
              onClick={handleVerifyOtp} // Use handleVerifyOtp for verification
              className="verify-btn"
            >
              Verify
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A64A2",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
